// extracted by mini-css-extract-plugin
export default {"sun_wrap":"theme-switch-button_sun_wrap__w3lzL","moon_wrap":"theme-switch-button_moon_wrap__TsTeY"};